import React from 'react';
import PropTypes from 'prop-types';
import { CamPlayer } from '@surfline/quiver-react';
import { sessionPropType } from '../../propTypes/session';

const SessionClipPlayer = ({ session, clip }) => {
  const createCameraObject = () => {
    return {
      streamUrl: clip.clipUrl,
      stillUrl: clip.thumbnail?.url?.replace('{size}', clip.thumbnail.sizes[2]),
      status: {
        isDown: !clip.clipUrl,
        message: "We're sorry we are still working on generating this clip.",
        subMessage: 'Clip is not available yet.',
        altMessage: 'Clip is not available yet.',
      },
    };
  };

  const { spot } = session;
  return (
    <div className="sl-cam-clip-player-container">
      {clip && (
        <CamPlayer
          playerId={clip?.clipId || 'sl-clip-player'}
          key={clip?.clipId || 'sl-clip-player'}
          camera={createCameraObject()}
          spotName={spot.name}
          spotId={spot.id}
          isClip
        />
      )}
    </div>
  );
};

SessionClipPlayer.propTypes = {
  session: sessionPropType.isRequired,
  clip: PropTypes.shape({
    clipId: PropTypes.string,
    clipUrl: PropTypes.string,
    thumbnail: PropTypes.shape({
      url: PropTypes.string,
      sizes: PropTypes.arrayOf(PropTypes.string),
    }),
  }),
};

SessionClipPlayer.defaultProps = {
  clip: null,
};

export default SessionClipPlayer;
